/** Aplicação direta do símbolo oficial; a geometria vive no SVG da marca. */
interface Props {
  className?: string;
  decorativa?: boolean;
  /**
   * Variante do símbolo conforme o fundo: `color` sobre superfícies claras,
   * `white` sobre Forest Green (sidebar institucional), `charcoal` para
   * contextos monocromáticos. Os arquivos são os vetores oficiais da marca —
   * nunca recolorir via CSS, o SVG certo já existe.
   */
  variante?: 'color' | 'white' | 'charcoal';
}

export function SimboloCeres({ className, decorativa = false, variante = 'color' }: Props): JSX.Element {
  return (
    <img
      src={`/brand/ceres/ceres-symbol-${variante}.svg`}
      className={className}
      alt={decorativa ? '' : 'CERES CRM'}
      {...(decorativa ? { 'aria-hidden': true } : {})}
    />
  );
}
